import { render, staticRenderFns } from "./icon_mdi_dashboard_ops.vue?vue&type=template&id=b5c074f6"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports